import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getProfile, updateProfile, changePassword } from '@/api/settingsApi';
import type { UpdateProfileRequest, ChangePasswordRequest } from '@/types/settings';

export function useProfile() {
  return useQuery({
    queryKey: ['settings', 'profile'],
    queryFn: getProfile,
  });
}

export function useUpdateProfile() {
  const mdQueryClient = useQueryClient();
  return useMutation({
    mutationFn: (mdData: UpdateProfileRequest) => updateProfile(mdData),
    onSuccess: () => {
      mdQueryClient.invalidateQueries({ queryKey: ['settings', 'profile'] });
    },
  });
}

export function useChangePassword() {
  return useMutation({
    mutationFn: (mdData: ChangePasswordRequest) => changePassword(mdData),
  });
}
